const MAX_PROFILE_IMAGE_DIMENSION = 720;
const PROFILE_IMAGE_OUTPUT_TYPE = 'image/webp';
const PROFILE_IMAGE_QUALITY = 0.82;
const PROFILE_IMAGE_MAX_BYTES = 280 * 1024;
const MAX_BANNER_IMAGE_WIDTH = 1600;
const MAX_BANNER_IMAGE_HEIGHT = 900;
const BANNER_IMAGE_OUTPUT_TYPE = 'image/webp';
const BANNER_IMAGE_QUALITY = 0.8;
const BANNER_IMAGE_MAX_BYTES = 420 * 1024;
const MAX_GALLERY_IMAGE_WIDTH = 1400;
const MAX_GALLERY_IMAGE_HEIGHT = 1400;
const GALLERY_IMAGE_OUTPUT_TYPE = 'image/webp';
const GALLERY_IMAGE_QUALITY = 0.78;
const GALLERY_IMAGE_MAX_BYTES = 360 * 1024;

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const image = new Image();

    image.onload = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(image);
    };

    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Nao foi possivel ler a imagem.'));
    };

    image.src = objectUrl;
  });
}

function canvasToBlob(canvas, type, quality) {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error('Nao foi possivel processar a imagem.'));
        return;
      }
      resolve(blob);
    }, type, quality);
  });
}

function sanitizeFileName(value, fallback) {
  return String(value || fallback)
    .replace(/\.[^.]+$/, '')
    .replace(/[^a-zA-Z0-9_-]+/g, '-')
    .replace(/^-+|-+$/g, '') || fallback;
}

async function optimizeImageFile(file, options) {
  if (!(file instanceof File) || !file.type.startsWith('image/')) {
    throw new Error('Arquivo de imagem invalido.');
  }

  if (typeof window === 'undefined') return file;

  const {
    maxWidth,
    maxHeight,
    outputType,
    initialQuality,
    minQuality,
    maxBytes,
    fallbackName,
  } = options;

  const image = await loadImage(file);
  const widthScale = image.width > maxWidth ? maxWidth / image.width : 1;
  const heightScale = image.height > maxHeight ? maxHeight / image.height : 1;
  const scale = Math.min(widthScale, heightScale, 1);

  const width = Math.max(1, Math.round(image.width * scale));
  const height = Math.max(1, Math.round(image.height * scale));

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext('2d', { alpha: true });
  if (!context) throw new Error('Nao foi possivel preparar a imagem.');

  context.drawImage(image, 0, 0, width, height);

  let quality = initialQuality;
  let blob = await canvasToBlob(canvas, outputType, quality);

  while (blob.size > maxBytes && quality > minQuality) {
    quality -= 0.08;
    blob = await canvasToBlob(canvas, outputType, quality);
  }

  const resized = scale < 1;
  if (blob.size >= file.size && !resized) {
    return file;
  }

  const safeName = sanitizeFileName(file.name, fallbackName);

  return new File([blob], `${safeName}.webp`, {
    type: outputType,
    lastModified: Date.now(),
  });
}

export async function optimizeProfileImage(file) {
  return optimizeImageFile(file, {
    maxWidth: MAX_PROFILE_IMAGE_DIMENSION,
    maxHeight: MAX_PROFILE_IMAGE_DIMENSION,
    outputType: PROFILE_IMAGE_OUTPUT_TYPE,
    initialQuality: PROFILE_IMAGE_QUALITY,
    minQuality: 0.5,
    maxBytes: PROFILE_IMAGE_MAX_BYTES,
    fallbackName: 'foto-perfil',
  });
}

export async function optimizeBannerImage(file) {
  return optimizeImageFile(file, {
    maxWidth: MAX_BANNER_IMAGE_WIDTH,
    maxHeight: MAX_BANNER_IMAGE_HEIGHT,
    outputType: BANNER_IMAGE_OUTPUT_TYPE,
    initialQuality: BANNER_IMAGE_QUALITY,
    minQuality: 0.46,
    maxBytes: BANNER_IMAGE_MAX_BYTES,
    fallbackName: 'banner',
  });
}

export async function optimizeGalleryImage(file) {
  return optimizeImageFile(file, {
    maxWidth: MAX_GALLERY_IMAGE_WIDTH,
    maxHeight: MAX_GALLERY_IMAGE_HEIGHT,
    outputType: GALLERY_IMAGE_OUTPUT_TYPE,
    initialQuality: GALLERY_IMAGE_QUALITY,
    minQuality: 0.46,
    maxBytes: GALLERY_IMAGE_MAX_BYTES,
    fallbackName: 'galeria',
  });
}
